import { render } from "./portals.html?vue&type=template&id=1403ce54&external"
import script from "./portals.js?vue&type=script&lang=js&external"
export * from "./portals.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__